import "bootstrap/dist/css/bootstrap.min.css";
import HomePage from "./HomePage";
import ServicePage from "./ServicePage";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function App() {
  const normalizedPath = window.location.pathname.replace(/\/+$/, "") || "/";
  const isServicePage = normalizedPath === "/service";

  return (
    <div
      className={`App ${isServicePage ? "service-app" : ""}`}
      style={!isServicePage ? { background: "#F7F8FA" } : undefined}
    >
      {isServicePage ? <ServicePage /> : <HomePage />}
    </div>
  );
}

export default App;
